/*
 * RATINGS & REVIEWS TABS
 * We plan to re-implement ratings tab from a different vender, until then this is currently unused
 * We are leaving ratings and reviews code commented out
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import AboutUs from './AboutUs';
import FuneralPlanning from './FuneralPlanning';
// import RatingsReviews from './RatingsReviews';
import Obituaries from './Obituaries';
import UpcomingServices from './UpcomingServices';
import _get from 'lodash/get';
import {setTabIndex} from '../../../../redux/actions';
import {buildDirectoryPath} from '../../../../../appModules/utilities/metaDataUtilities';
import {buildUrl} from '../../../../shared/utilities/urlHelpers';
import {
  getGATags,
  setVirtualPageView,
} from '../../../../shared/utilities/GAHelpers';
import {refreshAds} from '../../../../../appModules/utilities/refreshAds';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import {breakPointChecker} from '../../../../shared/utilities/breakPointChecker.js';
import appConfig from '../../../../../appConfig/AppConfig';
import './css/Tabs.styl';

const conf = appConfig();

export class TabsComp extends Component {
  static propTypes = {
    funeralHome: React.PropTypes.object.isRequired,
    planning: React.PropTypes.bool.isRequired,
    tabIndex: React.PropTypes.number.isRequired,
    dispatch: React.PropTypes.func,
  };

  state = {
    // ratingsBreakPointHit: false,
    aboutBreakPointHit: false,
    servicesBreakPointHit: false,
    flowersBreakPointHit: false,
    planningTabBreakPointHit: false,
  };

  componentDidMount() {
    window.addEventListener('resize', this.checkBreakPoint);

    this.checkBreakPoint();
  }

  componentDidUpdate(nextProps) {
    if (nextProps.tabIndex !== this.props.tabIndex) {
      refreshAds(['display-right-inview-1', 'display-right-inview-2']);
    }
  }

  checkBreakPoint = () => {
    this.setState({
      // ratingsBreakPointHit: breakPointChecker(1110),
      aboutBreakPointHit: breakPointChecker(1024),
      servicesBreakPointHit: breakPointChecker(950),
      flowersBreakPointHit: breakPointChecker(900),
      planningTabBreakPointHit: breakPointChecker(600),
    });
  };

  /* 
   * See comment at top of file
   * 
  getRatings(ratingsHeader) {
    let ratingsTab = null;
    let ratingsTabHeader = null;

    if (!this.props.funeralHome.profileData.suppressRatingsAndReviews) {
      ratingsTabHeader = <Tab className="tab-header">{ratingsHeader}</Tab>;
      ratingsTab = (
        <TabPanel forceRender>
          <RatingsReviews funeralHome={this.props.funeralHome} />
        </TabPanel>
      );
    }
    return {
      header: ratingsTabHeader,
      tab: ratingsTab,
    };
  }
  */

  render() {
    const {isPremium} = this.props.funeralHome;
    const {
      aboutBreakPointHit,
      // ratingsBreakPointHit,
      servicesBreakPointHit,
      planningTabBreakPointHit,
    } = this.state;

    const aboutHeader = aboutBreakPointHit ? 'About' : 'About Us';

    /* const ratingsHeader = ratingsBreakPointHit
      ? 'Reviews'
      : 'Ratings & Reviews'; */

    const servicesHeader = servicesBreakPointHit
      ? 'Services'
      : 'Upcoming Services';
    const planningHeader = planningTabBreakPointHit
      ? 'Planning'
      : 'Funeral Planning';

    const TAB_NAMES = [
      'tab_about_us',
      'tab_obituaries',
      'tab_services',
      // 'tab_ratings_and_reviews',
    ];

    if (isPremium) {
      TAB_NAMES.splice(1, 0, 'tab_funeral_planning');
    }

    const tabIndexUpdated = (tabIndex, lastTabIndex) => {
      const {page} = this.props;

      if (tabIndex !== lastTabIndex) {
        getGATags({
          eventCategory: 'fhd_tabs',
          eventAction: `${TAB_NAMES[tabIndex]}_click`,
          eventLabel: `fhd_${TAB_NAMES[tabIndex]}`,
        });

        const nextTabSlug = TAB_NAMES[tabIndex];
        const nextTabParameters = [{key: 'tab', value: nextTabSlug}];

        if (nextTabSlug === 'tab_obituaries') {
          nextTabParameters.push({
            key: 'page',
            value: page,
          });
        }
        const nextTabUrl = buildUrl(
          conf.vanityDomain,
          buildDirectoryPath(this.props.funeralHome),
          nextTabParameters
        );

        setVirtualPageView(nextTabUrl);
        history.pushState(null, null, nextTabUrl);
      }
      this.props.dispatch(setTabIndex({tabIndex}));
    };

    // const ratings = this.getRatings(ratingsHeader);

    return (
      <Tabs
        selectedIndex={this.props.tabIndex}
        onSelect={(tabIndex, lastTabIndex) => {
          tabIndexUpdated(tabIndex, lastTabIndex);
        }}
      >
        <TabList>
          <Tab className="tab-header">{aboutHeader}</Tab>
          {isPremium && <Tab className="tab-header">{planningHeader}</Tab>}
          <Tab className="tab-header">Obituaries</Tab>
          <Tab className="tab-header">{servicesHeader}</Tab>
        </TabList>

        <TabPanel>
          <AboutUs />
        </TabPanel>
        {isPremium && (
          <TabPanel>
            <FuneralPlanning />
          </TabPanel>
        )}
        <TabPanel>
          <Obituaries />
        </TabPanel>
        <TabPanel>
          <UpcomingServices />
        </TabPanel>
      </Tabs>
    );
  }
}

TabsComp.propTypes = {
  funeralHome: PropTypes.object.isRequired,
  planning: PropTypes.bool.isRequired,
  tabIndex: PropTypes.number.isRequired,
  dispatch: PropTypes.func,
};

const mapStateToProps = state => ({
  page: _get(state, 'obituaryStore.page'),
  planning: _get(state, 'planningStore.isPlanning'),
  tabIndex: _get(state, 'tabIndexStore.tabIndex'),
});

export default connect(mapStateToProps)(TabsComp);



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Tabs/index.js